import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CursoList from './CursoList';
import CursoForm from './CursoForm';
import DeletedCursosList from './DeletedCursosList';

const Cursos = () => {
  return (
    <Routes>
      <Route path="/" element={<CursoList />} />
      <Route path="/new" element={<CursoForm />} />
      <Route path="/:id/edit" element={<CursoForm />} />
      <Route path="/deleted" element={<DeletedCursosList />} />
      <Route path="*" element={<Navigate to="/cursos" replace />} />
    </Routes>
  );
};

export default Cursos;
